var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpExe522834000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.098 58.789h11.938l38.027-38.027v-5.2539l-3.3359-3.3438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.516 9.957l-5.9688-5.9648-54.805 54.797h11.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.062 58.789v-17.25l-17.254 17.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.387 58.789l21.676-21.672v-11.938l-33.609 33.609z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.473 0l-21.535 21.535v11.934l33.469-33.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.336 1.7812l-1.7812-1.7812h-8.375l-54.242 54.242v4.5469h7.3867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.938 0v17.117l17.117-17.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.828 0l-37.891 37.887v11.938l49.824-49.824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.938 100h78.125v-38.086h-78.125zm47.949-26.879h11.609v2.6484h-8.4453v3.4688h7.8633v2.6406h-7.8633v4.2617h8.7461v2.6367h-11.91zm-15.68 0h3.6953l3.1406 5.0312 3.0742-5.0312h3.6641l-4.8711 7.6055 5.3516 8.0547h-3.8164l-3.4688-5.4141-3.4805 5.4141h-3.793l5.3516-8.1719zm-13.5 0h11.609v2.6484h-8.4453v3.4688h7.8633v2.6406h-7.8633v4.2617h8.7461v2.6367l-11.91 0.003906z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpExe522834000000);
export default __webpack_public_path__ + "static/media/np_exe_522834_000000.3d5dd88635bfe2066eaae27a4d110e12.svg";
export { ForwardRef as ReactComponent };